// extracted by mini-css-extract-plugin
module.exports = {"trace":"ErrorBoundary_trace__UGLxv"};